"use client";

import { getListingCertificationBadge } from "@/app/libs/participantCertifications";

interface CertificationBadgeProps {
  minCertification?: string | null;
  category?: string | null;
  /** "card" = small pill over the card image; "detail" = big pill next to the listing title. */
  variant?: "card" | "detail";
}

/**
 * Tells a diver, before booking, whether a certification is needed:
 * green "No experience needed" or grey "<certification> required".
 */
const CertificationBadge: React.FC<CertificationBadgeProps> = ({
  minCertification,
  category,
  variant = "card",
}) => {
  const badge = getListingCertificationBadge({ minCertification, category });
  if (!badge) return null;

  if (variant === "detail") {
    return (
      <span
        className={`inline-flex items-center rounded-lg px-3 py-1.5 text-base font-bold ${
          badge.kind === "none"
            ? "bg-green-600 text-white"
            : "bg-neutral-200 text-neutral-800"
        }`}
      >
        {badge.label}
      </span>
    );
  }

  return (
    <span
      className={`max-w-full truncate rounded-md px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide shadow-sm ring-1 ${
        badge.kind === "none"
          ? "bg-green-600 text-white ring-white/25"
          : "bg-neutral-800/90 text-white ring-white/15"
      }`}
    >
      {badge.label}
    </span>
  );
};

export default CertificationBadge;
